import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAppSelector } from '@core/store/hooks';

/**
 * Inside the authenticated phase this only has to catch the unverified-email case: a guest
 * never reaches here, because the guest phase renders a different `<Routes>` tree entirely.
 */
export function ProtectedRoute() {
  const isAuthenticated = useAppSelector((s) => s.auth.isAuthenticated);
  const token = useAppSelector((s) => s.auth.token);
  const emailVerified = useAppSelector((s) => s.auth.user?.emailVerified);
  const location = useLocation();

  if (!isAuthenticated || !token) {
    return <Navigate to='/login' replace state={{ from: location.pathname }} />;
  }

  if (emailVerified === false) return <Navigate to='/verify-email' replace />;

  return <Outlet />;
}
